import { Container, Loader, Header, Content, Navbar, Grid, Row, Col } from 'rsuite';
import { useGetToken } from 'lib/auth';
import PortalDocumentView from 'containers/portal/PortalDocumentView';
import PortalWorkOrderView from 'containers/portal/PortalWorkOrderView';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { getCompanies } from 'lib/helpers/company';
import { useViewport } from './ViewportProvider';
import { Message } from 'drawers/Message';
import PortalInvoiceView from 'containers/portal/PortalInvoiceView';
import { getAllFields } from 'lib/helpers/field';
import PortalProfileView from 'containers/portal/PortalProfileView';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { isMobileOnly } from 'react-device-detect';

const ApplicationContainer = () => {
  const token: any = useGetToken(true);
  const client = useApolloClient();
  const { state } = useViewport();
  const { dispatch } = useViewport();
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState<any>(undefined);
  const [stripe, setStripe] = useState<any>(undefined);

  useEffect(() => {
    (async function getFieldsData() {
      const companies = await getCompanies(client);
      const fields = await getAllFields(client);
      const nextStripe = await loadStripe(companies[0].integrations?.stripePublishableKey || 'pk_na');
      setStripe(nextStripe);

      setCompany(companies[0]);
      dispatch({ type: 'SET_COMPANIES', payload: companies });
      dispatch({ type: 'SET_FIELDS', payload: fields });

      setLoading(false);
    })();
  }, []);

  const header = () => <>
    {token.data.tenant === 'bugaboo' && <span>Bugaboo Landscaping Ltd.</span>}
    {token.data.tenant === 'assiniboine' && <span>Assiniboine Landscaping Ltd.</span>}
    {token.data.tenant === 'greyrock' && <span>Grey Rock Snow Removal & Seasonal Lights Ltd.</span>}
    {token.data.tenant === 'kaladikitchens' && <span>Kaladi Kitchens</span>}
    {token.data.tenant === 'kaladiproperties' && <span>Kaladi Properties</span>}
  </>

  return <div>
    {loading
      ? <Loader content="Loading..." />
      : <>
        {token
          ? <div>
            <Grid fluid style={{ height: '100vh' }}>
              {/* <button onClick={() => (stripe as any).methodDoesNotExist()}>Break the world</button> */}
              <Row style={{ height: '100%' }}>
                <Col md={8} xsHidden style={{ padding: '30px 60px', borderRight: 'solid 1px #eee', height: '100%' }} className='text-right'>
                  <h3>{header()}</h3>
                </Col>
                <Col md={16} xs={24} style={{ padding: isMobileOnly ? '10px' : '30px 60px', height: '100%', overflowY: 'scroll' }}>
                  <h6 className='mb-12'>{header()}</h6>

                  <Elements stripe={stripe}>
                    {window.location.pathname.indexOf('/customer') > -1 && <PortalProfileView />}
                    {window.location.pathname.indexOf('/document') > -1 && <PortalDocumentView />}
                    {window.location.pathname.indexOf('/work-order') > -1 && <PortalWorkOrderView />}
                    {window.location.pathname.indexOf('/invoice') > -1 && <PortalInvoiceView />}
                    {window.location.pathname.indexOf('/test') > -1 && <div>Service Desk</div>}
                  </Elements>
                </Col>
              </Row>
            </Grid>
            <Message />
          </div>
          : <div>Invalid endpoint. Please contact support.</div>
        }
      </>
    }
  </div>

  return <div>application container</div>
}

export default ApplicationContainer;
